/**
 * Kalemin fiyat geçmişi (ortağın notu #13; ADR 0047 §5): verilmiş siparişlerin (onaylanmış,
 * iptal edilmemiş PO) satırları. Liman bugün serbest metindir (PO'nun teslim yeri, yoksa talebin
 * limanı); liman tablosu gelince (M13b) kimlik aynı birleştirmeyle eklenir. Kur yoktur: para
 * birimleri ayrı özetlenir.
 */

export interface PriceHistoryRow {
  purchaseOrderLineId: string;
  purchaseOrderId: string;
  poNo: string;
  /** Sipariş günü (`YYYY-MM-DD`). */
  orderDate: string;
  vesselId: string;
  vesselName: string;
  supplierName: string;
  port: string | null;
  quantity: number;
  unit: string;
  unitPrice: number;
  currency: string;
  /** İptal edilmemiş GRN'lerde kabul edilen. */
  accepted: number;
}

export interface PriceSummary {
  /** Liman ya da tedarikçi; limanı bilinmeyen satırlar `null`. */
  key: string | null;
  currency: string;
  last: number;
  lastDate: string;
  min: number;
  count: number;
}

/**
 * Liman ya da tedarikçi ve para birimi başına son fiyat (en son sipariş günü), en düşük fiyat ve
 * sipariş sayısı. Sıra: ada göre, bilinmeyen liman en sonda; aynı adda para birimine göre.
 */
export function priceSummary(
  rows: readonly PriceHistoryRow[],
  by: 'port' | 'supplier',
): PriceSummary[] {
  const groups = new Map<string, PriceSummary>();
  const ordered = [...rows].sort(
    (a, b) => a.orderDate.localeCompare(b.orderDate) || a.poNo.localeCompare(b.poNo),
  );
  for (const row of ordered) {
    const key = by === 'port' ? row.port : row.supplierName;
    const id = `${key ?? '\u0000'}|${row.currency}`;
    const current = groups.get(id);
    if (current) {
      current.last = row.unitPrice;
      current.lastDate = row.orderDate;
      current.min = Math.min(current.min, row.unitPrice);
      current.count += 1;
    } else {
      groups.set(id, {
        key,
        currency: row.currency,
        last: row.unitPrice,
        lastDate: row.orderDate,
        min: row.unitPrice,
        count: 1,
      });
    }
  }
  return [...groups.values()].sort((a, b) => {
    if (a.key === null || b.key === null) {
      if (a.key !== b.key) return a.key === null ? 1 : -1;
    } else if (a.key !== b.key) return a.key.localeCompare(b.key);
    return a.currency.localeCompare(b.currency);
  });
}
